module.exports = __webpack_public_path__ + "static/prismatic_spray-85102a07777337718845483044dde937.jpg";